import { render } from "./Footer.vue?vue&type=template&id=f4be8278&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./footer.scss?vue&type=style&index=0&id=f4be8278&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4be8278"]])

export default __exports__